import React from 'react'
import { ConfirmIndustryPrompt } from 'components/ConfirmIndustryPrompt'
import { useVerticalContext } from 'hooks/context/useVerticalContext'
import { BusinessComplianceForm } from './components/BusinessComplianceForm'

export const BusinessCompliance = () => {
  const { isIndustryConfirmed } = useVerticalContext()

  return isIndustryConfirmed ? <BusinessComplianceForm /> : <ConfirmIndustryPrompt />
}
